module.exports = __webpack_public_path__ + "img/screen.87203f5e.gif";